function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_902",
  "data-name": "Group 902",
  transform: "translate(-383.344 -217)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_6",
  "data-name": "Ellipse 6",
  cx: 9,
  cy: 9,
  r: 9,
  transform: "translate(383.344 217)"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_892",
  "data-name": "Group 892",
  transform: "translate(389.115 223.115)"
}, /*#__PURE__*/React.createElement("line", {
  id: "Line_57",
  "data-name": "Line 57",
  x1: 6,
  y2: 6,
  transform: "translate(0.23 -0.115)",
  fill: "none",
  stroke: "#fff",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_58",
  "data-name": "Line 58",
  x2: 6,
  y2: 6,
  transform: "translate(0.23 -0.115)",
  fill: "none",
  stroke: "#fff",
  strokeWidth: 1
})));

var SvgCloseCircle = function SvgCloseCircle(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCloseCircle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/close-circle.b8f36af0.svg";
export { ForwardRef as ReactComponent };